// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a80b1269","977":"4658319c"}[chunkId] + ".chunk.js";
};